<!-- Construction banner (non-production only) -->
@if (!isProduction) {
  <div
    class="construction-banner bg-[url('assets/images/construction.png')] bg-repeat w-full h-1 relative z-50"
  ></div>
}


<!-- Show skeleton loading screen while app is initializing -->
@if (loadingService.isLoading()) {
  <div>
    <app-skeleton-with-progress></app-skeleton-with-progress>
  </div>
} @else {
  <ngx-loading-bar [includeSpinner]="false" height="3px" color="#000"></ngx-loading-bar>
  <router-outlet></router-outlet>
  <!-- Spartan UI Toaster for notifications -->
  <hlm-toaster />
  <app-pwa-install-banner />
}

<!-- Global PDF export queue (persists across routes) -->
<app-pdf-export-downloads-panel />

<!-- Show main app content when loaded -->
